import "number-flow";
import Swiper from "swiper";
import { A11y, Autoplay, Navigation, Scrollbar, Pagination } from "swiper/modules";
import { getRenderBullet, addBulletProgressHandler } from "@/scripts/components/sliders";

const initializeNumberFlow = (flow) => {
  if (!flow) return;

  const useGrouping = flow.dataset.useGrouping === "1";

  flow.transformTiming = {
    duration: 1000,
    easing: "ease-out",
  };

  flow.opacityTiming = {
    duration: 1000,
    easing: "ease-out",
  };

  flow.addEventListener("mousedown", (event) => {
    if (event.detail > 1) {
      event.preventDefault();
    }
  });

  flow.format = { useGrouping: useGrouping };
  flow.update(0);
};

const runCounter = (flow) => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  flow.update(flow.dataset.end);
};

document.querySelectorAll(".element-stats").forEach((el) => {
  const container = el.querySelector(".swiper");
  const numSlides = el.querySelectorAll(".swiper-slide").length;
  const sliderPagination = el.querySelector(".slider-pagination");

  el.style.setProperty("--color-highlight", "var(--color-orange)");

  if (numSlides > 1) {
    const swiper = new Swiper(container, {
      modules: [A11y, Autoplay, Navigation, Scrollbar, Pagination],
      autoplay: {
        delay: 4000,
      },
      speed: 750,
      loop: true,
      navigation: {
        nextEl: el.querySelector(".slider-button-next"),
        prevEl: el.querySelector(".slider-button-prev"),
      },
      scrollbar: {
        el: el.querySelector(".swiper-scrollbar"),
        draggable: true,
      },
      slidesPerView: 1,
      spaceBetween: 24,
      pagination: {
        el: sliderPagination,
        clickable: true,
        renderBullet: getRenderBullet(),
      },
    });

    if (sliderPagination) {
      addBulletProgressHandler(swiper, sliderPagination);
    }

    swiper.autoplay.stop();

    const handleActiveSlide = (activeSlide) => {
      if (!activeSlide.classList.contains("did-run")) {
        const counters = activeSlide.querySelectorAll("number-flow[data-counter]");
        counters.forEach((counter) => {
          initializeNumberFlow(counter);
          runCounter(counter);
        });

        activeSlide.classList.add("did-run");
      }
    };

    swiper.on("autoplayStart", () => {
      if (swiper.enabled) {
        const visibleSlides = swiper.slides.filter((_, index) => {
          return index >= swiper.activeIndex && index < swiper.activeIndex + swiper.params.slidesPerView;
        });

        visibleSlides.forEach((slide) => {
          handleActiveSlide(slide);
        });
      } else {
        el.querySelectorAll(".swiper-slide").forEach((slide) => {
          handleActiveSlide(slide);
        });
      }
    });

    swiper.on("slideChange", () => {
      const visibleSlides = swiper.slides.filter((_, index) => {
        return index >= swiper.activeIndex && index < swiper.activeIndex + swiper.params.slidesPerView;
      });

      visibleSlides.forEach((slide) => {
        handleActiveSlide(slide);
      });
    });

    const observer = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          swiper.autoplay.start();
          observer.disconnect();
        }
      },
      {
        threshold: [0.7],
      },
    );

    observer.observe(el);
  }

  const staticStatsWrapper = el.querySelector(".static-stats-wrapper");

  if (staticStatsWrapper) {
    const counters = document.querySelectorAll("number-flow[data-counter]");

    counters.forEach((flow) => {
      initializeNumberFlow(flow);

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            runCounter(flow);
            observer.unobserve(flow);
          }
        });
      });

      observer.observe(flow);
    });
  }
});
